const dictionary_en = {
  select_lang: 'CHOOSE YOUR LANGUAGE:',
  lang: 'English',
  locale: 'en-US',
  lang_short: 'en',

  dateFormat: 'MM/dd/yyyy',
  datePlaceholder: 'MM/DD/YYYY',

  technical_error: 'A technical issue occurred. Please retry later.',
  technical_error_hard:
    'A technical issue occurred. Please contact the requester.<p style="color: #bbb; max-height: 200px">%s</p>',

  portal_link: 'https://paperfly.io/en',
  agb_link: 'https://paperfly.io/tos-en/',
  contact_link: 'https://paperfly.io/contact-en/',

  address_dialog_personalInfo: 'Personal information',
  address_dialog_firstName: 'First name',
  address_dialog_lastName: 'Last name',
  address_dialog_dateOfBirth: 'Date of birth',
  address_dialog_dateOfBirth_err_18: 'Registration is only allowed for adults.',
  address_dialog_contactInformation: 'Contact information',
  address_dialog_email: 'Email',
  address_dialog_phone: 'Phone',
  address_dialog_address: 'Address',
  address_dialog_street: 'Street',
  address_dialog_houseNumber: 'House no.',
  address_dialog_zipcode: 'ZIP code',
  address_dialog_city: 'City',
  address_dialog_countryCode: 'Country',

  dialog_atrust_settings_title: 'Qualified signature required',
  dialog_atrust_select_next_options: 'Choose an option to continue',
  dialog_atrust_register_done:
    'Video identification is complete. The signing process will start now.',
  dialog_atrust_register: 'Electronic Signature via Video Identification',
  dialog_atrust_register_help:
    'Create a qualified electronic signature (QES) via A-Trust and WebID (video identification).',
  dialog_atrust_login_exists: 'Log in with an existing ID Austria account',
  dialog_atrust_login_exists_help:
    'Already have an ID Austria account? Log in with your existing credentials.',
  dialog_atrust_error_on_registration:
    'An error occurred during video identification. Please try again.',
  dialog_atrust_cancelled_on_registration:
    'Video identification cancelled by user',
  dialog_atrust_unknown_error_on_registration:
    "Unknown error during video identification '%s'. Video identification not possible",
  dialog_atrust_awaiting_registration: 'Awaiting video identification...',
  dialog_atrust_already_registered:
    'A user with these details already has an account. Log in to the existing account?',
  dialog_atrust_login: 'Login',
  dialog_atrust_preparing_title: 'Preparing',
  dialog_atrust_preparing_help:
    'Please wait while we prepare the document for video identification.',
  dialog_atrust_preparing_help_login:
    'Please wait while we prepare the document for signing.',
  dialog_atrust_ready_to_sign_help:
    'Press START to complete the signature in the A-Trust window.',
  dialog_atrust_ready_for_webid_help:
    'Press “Start video identification” to continue in the A-Trust window.',
  dialog_atrust_awaiting_webid_help:
    'Please complete video identification in the A-Trust window.',
  dialog_atrust_awaiting_sign_help:
    'Please complete the signature in the A-Trust window.',
  dialog_atrust_prep_document: 'Preparing document (create request / finalise)',
  dialog_atrust_prep_check_registration: 'Checking video identification status',
  dialog_atrust_prep_document_error:
    'Could not prepare the document. Please try again.',
  dialog_atrust_start_webid: 'Start video identification',
  dialog_atrust_restart_webid: 'Restart video identification',
  dialog_atrust_status_check_hint:
    'Checking the status can take about 5 seconds. If the A-Trust window was closed for another reason, start video identification again.',
  dialog_atrust_status_check_help: 'Checking video identification status…',
  dialog_atrust_confirm_restart_registration:
    'Abort video identification status check and start video identification again?',
  dialog_atrust_confirm_abort_status_check:
    'Abort video identification status check?',
  dialog_atrust_registration_done_sign_hint:
    'Video identification completed successfully. Press START to sign in and complete the signature.',
  dialog_atrust_short_term_done_sign_hint:
    'Video identification completed successfully. You have 15 minutes to complete the signature in the A-Trust window.',
  dialog_atrust_short_term_expired:
    'The time to sign has expired. Please restart video identification.',
  dialog_atrust_document_sign: 'Document Sign',
  dialog_atrust_repeat_document_sign: 'Continue signing',
  dialog_atrust_sign_status_check_help: 'Checking signature status…',
  dialog_atrust_sign_status_check_hint:
    'Checking the status can take about 5 seconds. If the A-Trust window was closed for another reason, tap “Continue signing”.',
  dialog_atrust_complete_webid:
    'Complete video identification in the %s window',
  dialog_atrust_prep_completed_sub: 'Request · Document · Video identification',
  qes_step_create_request: 'Creating request',
  qes_step_create_request_hint: 'Please fill in the required data.',
  qes_ready_create_request_help: 'Press NEXT to fill in the required data.',
  qes_step_prepare_document: 'Preparing document',
  qes_step_check_registration: 'Checking registration status',
  qes_step_check_signature: 'Checking signature status',
  qes_step_prep_completed: 'Preparation completed',
  qes_step_prep_completed_sub: 'Request · Document · Registration',
  qes_step_complete_registration: 'Complete registration in the %s window',
  qes_step_complete_signing: 'Complete signing in the %s window',
  qes_step_auto_close_hint: 'Closes automatically in 3 sec.',
  qes_registration_readonly_fields_hint:
    'Some fields may be read-only because the data is taken directly from the documents to ensure full consistency. If you notice incorrect information, please go back to the document to correct it.',

  document_rejected_message: 'This document was rejected.',
  reject_document_title: 'Reject document',
  reject_document_info:
    'You are about to reject "%s". Please provide a reason.',
  reject_document_reason: 'Reason for rejection',
  reject_document_reason_placeholder:
    'Describe the reason for the rejection...',
  reject_document_form_data: 'Form data',
  reject_document_dont_submit_data: 'Do not submit form data',
  reject_document_dont_submit_data_help:
    'Delete existing form data and do not submit it',
  reject_document_submit_data: 'Submit form data',
  reject_document_submit_data_help: 'Submit existing form data',

  home_password_wrong: 'Wrong password',
  home_password_verification: 'Verification...',
  home_password_required: 'Password required',
  home_request_for_documents:
    '%s has requested from you the following documents',
  home_request_for_payment: '%s has requested from you a payments',
  home_will_pay: 'I would like to pay',

  home_pay_with: 'with my computer',
  home_now_pay: 'Pay now',
  home_now_load: 'Submit documents',
  home_now_load_one: 'Submit document',
  home_now_view: 'View documents',
  home_now_view_one: 'View document',
  home_now_info: 'Read',
  list_loaded_pages: 'Uploaded pages',

  home_will_docs: 'How would like to proceed?',
  home_with_mobile_scan: 'Scan the QR Code to switch to your phone',
  home_load_with: 'Continue on this computer',

  home_with_mobile: 'with my phone',
  home_webrtc_warning:
    'In order to be able to proceed with the ID verification you have to open the link in Safari.',
  home_pincode_required: 'Please enter the secure code.',
  home_pincode_failed: 'The code you entered is wrong.',
  home_request_closed:
    'This request has already been closed. Please contact the requester.',
  home_request_notexists:
    'This request does not exist. Please contact the requester.',
  home_qrcode_title: 'Just scan the QR code with your phone',
  home_pin_required: 'Secure code required',
  home_deadline_title: 'Deadline: %s',
  home_security_info: 'Only <b>%s</b> %s see your data.',
  home_security_info_part_may: 'can',
  home_security_info_part_will: 'will',

  home_cookies_main:
    'This website uses cookies to improve service, for analytical and advertising purposes. By continuing to use the service, you agree to our use of cookies as described in the Cookie Policy.',
  home_cookie_accept: 'Accept',
  home_cookie_necessary: 'Necessary',
  home_cookie_change: 'Settings',
  home_cookie_statistic: 'Statistics',

  confirm_bio_data_collecting_title: 'Consent',
  confirm_bio_data_collecting_message:
    'As part of the electronic signature, your writing speed, writing direction, writing pauses and, if appropriate, writing pressure (Special category data) are recorded and stored in encrypted form. This is to prove that you have written the signature. If you do not consent to the processing of this data, you have the option of signing on paper. You have the right to revoke your consent at any time. Revocation of consent does not affect the legality of the processing carried out on the basis of your consent until revocation.',
  confirm_bio_data_collecting_confirm: 'Consent',

  user_credentials_title: 'Necessary data',

  complete_page_perform: 'Continue',
  complete_page_title: 'Confirmation Required',
  complete_page_message:
    'The data you have entered so far will be transmitted to %s. Please note that once submitted, the data can no longer be edited.',

  qr_direkt_request_or: 'or',
  qr_direkt_request_message: 'enter request URL directly',
  qr_start_what_next: 'How do you want to proceed',
  qr_start_scan_btn: 'Scan start',
  qr_start_request_btn: 'Start request',
  qr_paste_url_placeholder: 'Paste request URL',
  qr_start_save_template: 'Save template',
  qr_start_start_template: 'Start',
  qr_start_ignore_template: "Ignore and don't ask again",
  qr_start_delete_template: 'Delete %s templates?',
  qr_start_delete_one_template: 'Delete template',
  qr_start_template_not_found:
    'This template could not be found and cannot be started. You can delete it from your list or keep it and try again later.',
  qr_start_template_later: 'Later',
  offline_template_unavailable:
    'This template is not available offline. Please connect to the internet and open it once to save it for offline use.',
  offline_template_submit:
    'An internet connection is required to submit this request. Please go online and try again.',
  pwa_update_title: 'Update available',
  pwa_update_applying: 'Updating app…',
  pwa_update_message:
    'A new version of the app is available. Update now? Unsaved changes will be lost.',
  pwa_update_now: 'Update',
  pwa_update_later: 'Later',
  pwa_install_prompt_message:
    'Do you want to use the Paperfly App from your home screen?',
  pwa_install_prompt_link: 'See the installation guide',
  pwa_install_guide_popup_title: 'Install Paperfly App',
  pwa_install_guide_intro:
    'Install the app on your home screen for faster access.',
  pwa_install_guide_ios_title: 'Install on iPhone or iPad',
  pwa_install_guide_ios_step_1: 'Open this page in Safari.',
  pwa_install_guide_ios_step_2: 'Tap the Share button in the browser toolbar.',
  pwa_install_guide_ios_step_3: 'Choose "Add to Home Screen" and confirm.',
  pwa_install_guide_android_title: 'Install on Android',
  pwa_install_guide_android_step_1: 'Open the browser menu.',
  pwa_install_guide_android_step_2:
    'Tap "Install app" or "Add to Home screen".',
  pwa_install_guide_android_step_3: 'Confirm the installation.',
  pwa_install_guide_samsung_step_1: 'Open the browser menu.',
  pwa_install_guide_samsung_step_2: 'Tap "Add page to" or "Install app".',
  pwa_install_guide_samsung_step_3: 'Choose "Home screen" and confirm.',
  pwa_install_guide_firefox_android_step_1: 'Open the browser menu.',
  pwa_install_guide_firefox_android_step_2:
    'Tap "Install" or "Add to Home screen".',
  pwa_install_guide_firefox_android_step_3: 'Confirm the installation.',
  pwa_install_guide_default_title: 'Install in your browser',
  pwa_install_guide_default_step_1: 'Open the browser menu.',
  pwa_install_guide_default_step_2:
    'Look for "Install app" / "Add to Home screen".',
  pwa_install_guide_default_step_3: 'Confirm and follow the prompts.',

  qr_start_scan: 'Scan a Paperfly QR-Code please.',
  qr_start_message:
    'In order to use a QR-Code scanner, please grant access to your webcam...',

  list_done: 'Complete',
  list_send_docs: 'Submit documents',
  list_request_processing: 'In progress',
  list_title_documents: 'Documents:',
  list_title_scan_documents: 'Please submit the following documents:',
  list_title_got_documents: 'You have received the following documents:',
  list_expired_warning_text:
    'The deadline for the submission of the documents has expired. Please contact the requester.',
  list_success_message: 'The documents have been successfully submitted %s.',
  document_success_message: 'The Document have been successfully submitted %s.',
  list_success_message_at: ' at',
  list_item_scanned_document: 'Scanned document',
  list_item_scann_next: 'Continue scanning',
  list_item_original_document: 'Original document',
  list_load_saved_documents:
    '<p>There is data for this request that has been cached.</p> Do you want to restore the intermediate status?',
  list_load_saved_documents_yes: 'Yes - continue editing',
  list_load_saved_documents_no: 'No - start over',

  standalone_draft_notification_title: 'Continue process',
  standalone_draft_notification_text: 'Saved data exists for template "%s".',
  standalone_draft_restore:
    '<p>There is cached data for template "%s".</p>Do you want to continue editing?',
  standalone_draft_discard_other:
    'You have saved data for template "%s". If you start a new template, the previously saved data will be lost.',
  standalone_draft_continue: 'Continue',
  standalone_draft_saved_at: 'Last saved: %s',
  standalone_draft_new_start: 'New start',
  standalone_draft_restart: 'Start process anew',

  idcheck_summary: 'ID-Check - Summary',
  idcheck_take_photo: 'Capture image',
  idcheck_start_camera: 'Start cam',
  idcheck_page_selfie_step_title: 'Selfie',
  idcheck_page_title_selfie: 'Self-portrait photo',
  idcheck_page_title_pass: 'ID card',
  idcheck_scan_pass_item_title: 'Scan your ID card',
  idcheck_scan_pass_item_message_part1: 'Please scan your ',
  idcheck_scan_pass_item_message_part2: ' or ',
  idcheck_idcard: 'ID card',
  idcheck_pass: 'passport',
  idcheck_doselfie_item_title: 'Your photo',
  idcheck_doselfie_item_message: 'Almost done, now please take a selfie.',
  idchek_document_front_side_step_title: 'Front side',
  idchek_document_front_side_title: 'Front side',
  idchek_document_front_side_desc_passport:
    'Please upload a photo of your Passport.',
  idchek_document_front_side_desc_identificationCard:
    'Please upload a photo of the front side of your ID card.',
  idchek_document_front_side_desc_driversLicense:
    'Please upload a photo of the front side of your Drivers License.',
  idchek_document_doc_photo_step_title: 'Document photo',
  idchek_document_doc_photo_title: 'Please upload a photo of your Passport.',
  idchek_document_doc_photo_desc: 'Please upload a photo of your Passport.',
  idchek_document_back_side_step_title: 'Back side',
  idchek_document_back_side_title: 'Back side',
  idchek_document_back_side_desc_identificationCard:
    'Please upload a photo of the back side of your ID card.',
  idchek_document_back_side_desc_driversLicense:
    'Please upload a photo of the back side of your ID card.',
  idchek_document_live_photo_step_title: 'Live photo',
  idchek_document_live_photo_title: 'Live photo',
  idchek_document_live_photo_desc:
    'Please hold your %s in front of your cam so that the reflection of the document holograms is visible.',
  idchek_document_select_doc_type_step_title: 'Document type',
  idchek_document_select_doc_type_title:
    'What type of document do you want to use?',
  idchek_document_select_doc_type_desc:
    'What type of document do you want to use?',
  continue_on_mobile: 'Continue on phone',
  continue_on_mobile_title: 'Switch to your smartphone',
  idchek_do_on_desktop: 'Continue on this computer',
  continue_on_mobile_continue: 'Switch to your smartphone',
  continue_on_mobile_or_desktop: 'How would you like to proceed?',
  continue_on_mobile_after_done:
    'After finishing on your smartphone, click on the CONTINUE button to proceed.',
  id_check_doc_type_identificationCard: 'ID Card',
  id_check_doc_type_passport: 'Passport',
  id_check_doc_type_driversLicense: 'Drivers License',
  idcheck_hold_phone_camera_information:
    'Please hold your document in front of your cam so that the reflection of the document holograms is visible.',
  idcheck_hold_web_camera_information:
    'Pleas hold on Your document in front of the Your computer Web Camera, so that reflection of document hologram can be visible (like an example photo).',
  idcheck_load_photo_information:
    'Please load a Scan or Photo (with good resolution) of Your %s',

  cropper_is_to_small_message: 'The image is too small. Please try again.',
  cropper_repeat: 'New',
  cropper_crop_on: 'Crop on',
  cropper_crop_off: 'Crop off',
  cropper_next: 'Next',

  action_rotate: 'Rotate',
  action_replace: 'Replace',

  forms_fill_next: 'Continue',
  forms_fill_later: 'Complete it later',
  forms_cancel_changes: 'Discard changes',
  forms_required: 'This field is required',
  forms_wrong_digit: 'Please enter a valid number',
  forms_wrong_email: 'Please enter a valid e-mail',
  forms_wrong_value: 'Please enter a valid value',
  forms_wrong_email_phone: 'Please enter a valid e-mail or phone number',
  forms_return_to_pdf: 'Return to PDF View',
  forms_wrong_phone: 'Please enter a valid phone number',
  forms_external_validation_error:
    'An error occurred during form validation. You cannot complete this form. Please contact the requester or try again later.',
  forms_external_validation_wait:
    'Please wait — your form entries are being validated by the requester.',
  forms_external_validate: 'Validate',
  forms_pdf_as_quickform: 'Quick Form View',

  documents_confirmed: 'Confirmed',

  filter_document: 'Document',
  filter_photo: 'Photo',
  filter_bwmode: 'Grayscale',

  pdf_prev_page: 'Previous page',
  pdf_next_page: 'Next page',
  pdf_form_hide_smartfill: 'Hide input assistance',
  pdf_form_show_smartfill: 'Start input assistance',
  pdf_smartfill_step: 'Step:',
  pdf_return_from_smartfill:
    'We have entered your inputs into the document. Please review the document.',

  dialog_send_now: 'Send documents now?',
  dialog_delete_all: 'Delete all pages?',
  dialog_delete_page: 'Delete the selected page?',
  dialog_delete_page_x: 'Delete page %s?',
  dialog_delete_pages: 'Delete the selected pages?',
  dialog_load_all_required: 'Please upload all the required documents.',
  dialog_attention: 'Attention',
  dialog_warning: 'Warning',
  dialog_processing: 'in progress...',
  dialog_fill_all_fields: 'Please fill all fields.',
  dialog_sending: 'Submitting...',
  dialog_error_on_send:
    'An error occurred while uploading the documents. Please try again later.<br/><br/><div style="text-align: left; max-height: 70vh; overflow: auto;padding-left: 10px; font-size: 11px; color: #999">%s</div>',
  dialog_error_on_send_invalid_image:
    'At least one uploaded image is damaged or in an unsupported format. Please go back to the listed document(s), upload or take the photo again, then submit once more.<br/><br/><div style="text-align: left; max-height: 70vh; overflow: auto;padding-left: 10px; font-size: 11px; color: #999">%s</div>',
  sender_invalid_image_hint:
    'Image is damaged or unsupported. Please upload or photograph it again.',
  dialog_fill_all_required: 'Please fill in all required fields.',
  dialog_changies_will_removed:
    'All changes will be discarded. \n"Do you really want to continue?',
  dialog_continue: 'Proceed',

  dialog_required_document_IMMEDIATE_CONFIRMATION: 'Please confirm "%s".',
  dialog_required_document_ID_CHECK: 'Please run the ID check.',
  dialog_required_document_FORM: 'Please fill out "%s"',
  dialog_required_document_FORM_PDF: 'Please fill out "%s".',
  dialog_required_document_DOCUMENT: 'Please upload or take a photo of "%s".',
  dialog_required_document_PAYMENT: 'Please make the payment.',
  dialog_required_document_INFORMATION: 'Please read the document "%s".',

  footer_imprint: 'Imprint',
  footer_conditions: 'Privacy Notice & TOS',
  footer_privacy: 'Privacy',
  footer_support: 'Support',

  thankyou_is_done: 'Thanks, you’re all done!',
  thankyou_receive_your_documents: '%s has now received your documents.',
  thankyou_you_may_close: 'You can now close this tab.',

  info_popup_docs_from: 'You have received this request from <b>%s</b>. ',
  info_popup_message_part1: 'This service is powered by ',
  info_popup_message_part2:
    '. With Paperfy you can collect data, documents, eSignatures and payments. If you want to know more about Paperfly, have a look at this short ',
  info_popup_message_part3: ' .',
  info_popup_emailto_sender_1: 'You can contact %s at ',
  info_popup_emailto_sender_2: '.',

  upload_load_next_page: 'Please upload %s more pages',
  upload_all_done: 'All pages are completed',
  upload_delete_page: 'Delete page',
  upload_camera: 'Take a photo',
  upload_disk: 'Upload',
  upload_file: 'Choose file',

  sort_next_x_pages: '%s more pages',
  sort_new_page: 'New page',
  sort_next_x_pages_photo: '%s more photos',
  sort_new_page_photo: 'New photo',
  sort_prepare_page_x: 'Please prepare page %s',
  gallery_select_pages: 'Select pages',
  gallery_x_from_y_selected: '%s out of %s selected',

  payment_creditcard: 'Credit card',
  payment_sepa: 'SEPA',
  payment_wallet: 'Wallet',
  payment_error_message: 'An error occurred while processing the payment',
  payment_error_title: 'Payment failed',
  payment_do_pay: 'Pay', // TODO
  payment_pay: 'Pay',
  payment_sepa_information:
    'You have agreed to the direct debit mandate. The amount %s will be debited from your bank account.',
  payment_paid: 'Paid',
  payment_summ: 'Amount',
  payment_change_payment_method: 'Change the payment method',
  payment_select_payment_method: 'Please choose a payment method',
  payment_pay_x: 'Pay %s',
  payment_iban: 'IBAN',
  payment_sepa_long_information:
    'By agreeing to the SEPA direct debit mandate, you authorize Paperfly and Stripe to collect payments from your bank account by direct debit. At the same time, you instruct your bank to redeem the direct debits drawn by Paperfly and Stripe. Note: You can request a refund of the amount debited within eight weeks, starting with the debit date. The conditions agreed with your bank apply.', // TODO
  payment_confirm_sepa: 'Confirm the direct debit mandate',
  payment_wallet_not_available: 'Currently unavailable',

  viewer_download_required_title: 'Download document',
  viewer_download_required_message:
    'Please download the document and save or print it before you proceed.',

  forms_sign: 'Sign',
  forms_sign_with_yes: 'Sign with yes®',
  forms_sign_with_atrust: 'Sign with Atrust',
  forms_sign_please: 'Please sign',

  camera_disabled_title: 'Paperfly would like to access the Camera',
  camera_disabled_message:
    'Camera access was blocked. Without this permission the camera cannot be used.',
  camera_disabled_help_chrome:
    'To allow the camera again: click the lock or camera icon on the left of the address bar → set Camera to “Allow” → reload the page and try again.',
  camera_disabled_help_safari_ios:
    'To allow the camera again: in Safari tap “aA” on the left of the address bar → Website Settings → set Camera to “Allow” → return to the app and try again.',
  camera_disabled_help_safari:
    'To allow the camera again: Safari menu → Settings for This Website → set Camera to “Allow” → reload the page and try again.',
  camera_disabled_help_firefox:
    'To allow the camera again: click the permissions icon on the left of the address bar → allow Camera → reload the page and try again.',
  camera_disabled_help_generic:
    'Open your browser’s site settings, allow camera access for this page, then try again.',
  camera_permission_preprompt:
    'Your browser will ask for camera access next. Please choose “Allow”.',
  camera_permission_continue: 'Start camera',
  camera_permission_retry: 'Try again',
  camera_starting_message: 'Starting camera…',
  camera_error_message: 'No camera has been found',
  camera_error_message2: 'Camera does not work',

  common_error: 'Error',
  common_page: 'Page ',
  common_page_x: 'Page %s',
  common_all: 'All',
  common_page_x_from_y: 'Page %s / %s',
  common_page_x_from_y_2: 'Page %s out of %s',
  common_yes: 'Yes',
  common_name: 'Name',
  common_email: 'Email',
  common_count_selected: '%s selected',

  sender_cant_send_request: 'The action cannot be completed',
  //qes
  dialog_edit_will_off_after_qes_title: 'Have you completed all fields?',
  dialog_edit_will_off_after_qes:
    'Please double-check that all required fields have been filled in. Once the document has been signed, no further changes can be made.',
  esign_sign_type_not_supported: 'Qualified signature of "%s" not supported',

  //signme
  signme_now_document_sign: 'Sign document with qualified signature',
  signme_settings_registration_info:
    '<b>sign-me</b> is a service of D-Trust GmbH. We work with D-Trust to offer you <b>Qualified Signatures</b>.',
  dialog_signme_settings_title: 'Connect to sign-me',
  dialog_signme_preparing_title: 'Preparing',
  dialog_signme_preparing_help:
    'Please wait while we prepare the document for sign-me registration.',
  dialog_signme_preparing_help_login:
    'Please wait while we prepare the document for signing.',
  dialog_signme_ready_to_register_help:
    'Press “Set up” to continue registration in the sign-me window.',
  dialog_signme_ready_to_sign_help:
    'Press START to complete the signature in the sign-me window.',
  dialog_signme_registration_done_sign_hint:
    'Registration completed successfully. Press START to sign with your newly created account.',
  dialog_signme_awaiting_register_help:
    'Please complete registration in the sign-me window.',
  dialog_signme_awaiting_sign_help:
    'Please complete the signature in the sign-me window.',
  dialog_signme_restart_signing: 'Restart signature',
  dialog_signme_status_check_hint:
    'Checking the status can take about 5 seconds. If the sign-me window was closed for another reason, restart the signature.',
  dialog_signme_status_check_help: 'Checking signature status…',
  dialog_signme_confirm_restart_signing:
    'Abort signature status check and start signature again?',
  dialog_signme_confirm_abort_status_check: 'Abort signature status check?',
  signme_settings_registration_form_title: 'Your data according to ID',
  signme_settings_label_mobilePhoneNumber:
    'Mobile phone number (e.g. +49 123456789)',
  INVALID_PHONE_NUMBER_SIGNME: 'Invalid mobile phone number.',
  signme_settings_label_mobilePhoneNumber_info:
    'Separate the area code from the rest of the mobile phone number with a space',
  signme_settings_label_emailAddress: 'Email',
  signme_settings_label_givenNames: 'First name',
  signme_settings_label_familyName: 'Last name',
  signme_settings_processing_data: 'Processing',
  signme_settings_registration_done: 'sign-me successfully connected',
  signme_settings_registration_failed:
    'An error occurred while trying to connect sign-me. Please try again later.',
  signme_settings_nopopup_message:
    'Pop-up dialogs must be enabled to connect sign-me',
  yes_settings_nopopup_message:
    'Pop-up dialogs must be enabled to connect yes®',
  atrust_settings_nopopup_message:
    'Pop-up dialogs must be enabled to connect Atrust',
  signme_settings_nopopup_title: 'Check your browser settings',
  popup_blocked_help_chrome:
    '<b>Allow pop-ups in Google Chrome</b><br/><br/><b>Recommended (no reload):</b><br/>• Look in the address bar — a blocked pop-up icon often appears there (crossed-out window).<br/>• Click it and allow pop-ups for this website.<br/>• Then tap Start again — do not reload the page, or entered data may be lost.<br/><br/><b>If no icon is visible:</b><br/>• Click the three-dot menu at the top right → Settings.<br/>• Privacy and security → Site settings → Pop-ups and redirects.<br/>• Allow pop-ups for this website (custom exception).<br/>• Return to Paperfly and tap Start again — reload only as a last resort.',
  popup_blocked_help_edge:
    '<b>Allow pop-ups in Microsoft Edge</b><br/><br/><b>Recommended (no reload):</b><br/>• Look in the address bar — a blocked pop-up icon often appears there (crossed-out window).<br/>• Click it and allow pop-ups for this website.<br/>• Then tap Start again — do not reload the page, or entered data may be lost.<br/><br/><b>If no icon is visible:</b><br/>• Click the three-dot menu at the top right → Settings.<br/>• Cookies and site permissions → Pop-ups and redirects.<br/>• Allow pop-ups for this website.<br/>• Return to Paperfly and tap Start again — reload only as a last resort.',
  popup_blocked_help_safari_ios:
    '<b>Allow pop-ups in Safari on iPhone or iPad</b><br/><br/><b>Recommended (no reload):</b><br/>• Check the address bar or a “Pop-up Blocked” notice and allow the pop-up if offered.<br/>• Then tap Start again — do not reload the page, or entered data may be lost.<br/><br/><b>If that is not possible:</b><br/>• Open the Settings app → Safari.<br/>• Turn off Block Pop-ups.<br/>• Return to Paperfly and tap Start again — reload only as a last resort.',
  popup_blocked_help_safari:
    '<b>Allow pop-ups in Safari</b><br/><br/><b>Recommended (no reload):</b><br/>• Look in the address bar — a blocked pop-up notice or icon often appears there.<br/>• Allow pop-ups for this website.<br/>• Then tap Start again — do not reload the page, or entered data may be lost.<br/><br/><b>If no notice is visible:</b><br/>• Safari menu → Settings (or Preferences…) → Websites → Pop-up Windows.<br/>• Set this website to Allow.<br/>• Return to Paperfly and tap Start again — reload only as a last resort.',
  popup_blocked_help_firefox:
    '<b>Allow pop-ups in Mozilla Firefox</b><br/><br/><b>Recommended (no reload):</b><br/>• Look in the address bar or info bar — a blocked pop-up notice often appears there.<br/>• Click it and allow pop-ups for this website.<br/>• Then tap Start again — do not reload the page, or entered data may be lost.<br/><br/><b>If no notice is visible:</b><br/>• Menu → Settings → Privacy & Security → Permissions.<br/>• Next to Block pop-up windows → Exceptions… and allow this website.<br/>• Return to Paperfly and tap Start again — reload only as a last resort.',
  popup_blocked_help_generic:
    '<b>Allow pop-ups in your browser</b><br/><br/><b>Recommended (no reload):</b><br/>• Look in the address bar — a blocked pop-up icon often appears there (crossed-out window).<br/>• Click it and allow pop-ups for this website.<br/>• Then tap Start again — do not reload the page, or entered data may be lost.<br/><br/><b>If no icon is visible:</b><br/>• Open your browser settings and search for Pop-ups.<br/>• Allow pop-ups for this website.<br/>• Return to Paperfly and tap Start again — reload only as a last resort.',
  signme_settings_label_name: 'User',

  signme_settings_label_status: 'Status',
  signme_settings_label_created: 'Created on',
  signme_settings_label_dateOfBirth: 'Date of birth',
  signme_settings_label_placeOfBirth: 'Place of birth',
  signme_settings_label_placeOfResidence_street: 'Street',
  signme_settings_label_placeOfResidence_city: 'City',
  signme_settings_label_placeOfResidence_zipCode: 'ZIP code',
  signme_settings_label_placeOfResidence_country: 'Country',

  esignature_sign_document_error_message:
    'Creation of signature for this document could not be completed',
  esignature_sign_document_error_title: 'Error on creating Signature',
  esignature_document_signed: 'Document successfully signed',

  error_field_is_required: 'This field is required.',
  INVALID_EMAIL: 'Invalid e-mail',
  signme_settings_label_register: 'Set up',

  request_stepper_check_and_send: 'Please check your entries before sending.',

  title_add: 'Add',
  title_attention: 'Information',
  title_show_more: 'Show more',
  title_edit: 'Edit',
  title_check: 'Done',
  title_yes: 'Yes',
  title_no: 'No',
  title_ok: 'Ok',
  title_sendout: 'Send',
  title_will_prepared: ' is beeing processed...',
  title_preparing: 'Preparing',
  title_load: 'Loading',
  title_fill: 'Fill out',
  title_change: 'Edit',
  title_execute: 'Run',
  title_read: 'Read',
  title_read_and_accept: 'Read & Accept',
  title_had_read: 'Jump to last page',
  title_see: 'View',
  title_do_select: 'Choose',
  title_confirmation: 'Confirmation',
  title_confirm: 'Confirm',
  title_unconfirm: 'Revoke confirmation',
  title_unconfirm_short: 'Revoke',
  title_delete: 'Delete',
  title_successfull: 'Successful',
  title_successfull_sent: 'Successful sent',
  title_cancel: 'Cancel',
  title_select: 'Choose',
  title_dropdown_select: 'Select...',
  title_done: 'Done',
  title_summary: 'Summary',
  title_close: 'Close',
  title_reject: 'Reject',
  title_reject_and_send: 'Reject and complete',
  title_information: 'Information',
  title_or: 'or',
  title_back: 'Back',
  title_prev: 'Previous',
  title_next: 'Next',
  title_continue: 'Continue',
  title_start: 'Start',
  title_fillin: 'Fill In',
  title_read_next: 'Continue reading',
  title_save: 'Save',
  title_personal_message: 'Message from the sender:',
  title_documents_request: 'Request',
  title_loading: 'Loading',
  title_download: 'Download',
  title_print: 'Print',
  title_print_and_sign: 'Print and sign',
  title_camera: 'Camera',
  title_upload_signature: 'Upload signature',
  title_sign_on_mobile: 'Sign on Smartphone',
  title_sign_on_screen: 'Sign on screen',
  title_please_choose: 'Please choose',
  title_done_request: 'Complete request?',
  title_done_request_confirm: 'Do you really want to complete this request?',
  title_done_request_rest_signatures:
    'The following signature fields are still open:',
  title_done_request_with_sign_confirm:
    'There are additional signature fields available. Are you sure you want to complete this request?',
  title_step: 'Step',
  title_apply: 'Apply',
  title_today: 'Today',

  title_use_last_signature: 'Use last signature',
  sign_on_mobile_info: 'Scan this QR code with your phone',
  sign_on_mobile_set_failed:
    'An error occurred while trying to send Signature. Please try again later.',

  post_request_save_email_message:
    'Would you like to receive a copy of the data by email or SMS?',
  post_request_save_email_only_message:
    'Would you like to receive a copy of the data by email?',
  post_request_save_email_success:
    'You will shortly receive %s with a download link.',
  post_request_your_email: 'Your email',
  post_request_your_email_message: 'Please enter your email or phone number',
  post_request_your_phone_only_message: 'Please enter your phone number',
  post_request_your_email_only_message: 'Please enter your email',
  post_request_wrong_email_phone: 'Please enter a valid e-mail or phone number',
  post_request_wrong_phone_only: 'Please enter a valid phone number',
  post_request_wrong_email_only: 'Please enter a valid e-mail',
  post_request_email: 'E-Mail',
  post_request_sms: 'SMS',

  create_case_message_1: 'You’re almost done!',
  create_case_message_2:
    'Please enter your name and your email or phone number.',
  create_case_your_data: 'Your data:',
  create_case_recipient: 'Recipient %s ',
  create_case_recipient_data: '%s data:',
  create_case_your_name: 'Your name',
  create_case_your_firstName: 'Your first name',
  create_case_your_lastName: 'Your last name',
  create_case_recipient_name: 'Recipient %s Name',
  create_case_name: 'Name',
  create_case_role_name: '%s name',
  create_case_role_email: '%s email',
  create_case_role_phone: '%s phone number',
  create_case_role_email_phone: '%s email or phone number',
  create_case_email_phone: 'Email or phone number',
  create_case_your_email_phone: 'Your email or phone number',
  create_case_phone: 'Your phone number',
  create_case_recipient_email_phone: 'Recipient %s email or phone number',
  create_case_recipient_phone: 'Recipient %s phone number',
  create_case_rights_text:
    'I have read the <a class="link external" href="https://paperfly.io/privacy/" target="_blank">Privacy Policy</a>. I agree to the electronic storage and processing of my entered data.' +
    '<p><i>Note: The consent can be revoked at any time for the future by email to %s.</i></p>',
  recent_templates: 'Saved Templates',
  qr_add_new_template: 'Add new Template',
  qr_new_template: 'New Template',

  restart_app_title: 'Refresh required',
  restart_app_message: 'The application needs to be refreshed',
  restart_app_no: 'Cancel',
  restart_app_yes: 'Refresh',

  merkur_message_1:
    'May we contact you by email or SMS for future confirmations?',
  merkur_message_2:
    'This not only makes your banking transactions significantly easier, but also makes an active contribution to environmental and climate protection. If you agree, simply complete the following information.',

  merkur_sendout_agree: 'Yes, I would like to be contacted by email or SMS.',

  dialog_aes_popup_title: 'Confirm your identity',
  dialog_opt_popup_title: 'Two factor authentication',
  aes_popup_docs_title:
    'The following documents must signed with an advanced signature',
  aes_popup_sign: 'SIGN',
  aes_popup_label_agb:
    'I hereby confirm that my first and last name, the e-mail and the mobile phone number are correct',
  aes_popup__info: 'Your signature will include the following data: ',
  opt_enter_code:
    'Please enter the SMS code that we sent to your mobile phone ',
  opt_verify: 'Verify code',
  aes_popup_if_data_wrong_absender: ' the Sender',
  aes_popup_label_name: 'Name',
  aes_popup_label_emailAddress: 'Email',
  aes_popup_label_phone: 'Mobile phone',
  aes_popup_if_data_wrong: 'If your data is incorrect, please contact ',
  opt_popup_error:
    'A technical error has occurred. Please try again at a later time',
  opt_get_code: 'Request verification code',
  opt_code_success: 'You have successfully authenticated',

  app_send_err: 'Send error:',
  app_err_desc: 'Description (optional)',
  app_fatal_err: 'We are sorry, but an internal error occurred.',
  app_restart_app: 'Restart Application',
  app_err_send: 'Send'
};

export default dictionary_en;
